import { useState } from "react";
import { CaretDown, CaretUp, Lightning } from "@phosphor-icons/react";

export function PromotedBanner({ items }) {
  const [open, setOpen] = useState(false);
  if (!items?.length) return null;
  return (
    <div className="rounded-xl border border-slate-900 bg-slate-900 text-white px-3 py-2 text-[12px]" data-testid="taches-promoted">
      <button className="w-full flex items-center justify-between gap-2 text-left" onClick={() => setOpen(!open)} data-testid="taches-promoted-toggle">
        <span className="font-extrabold sm:uppercase sm:tracking-widest text-[11px] sm:text-[10px] text-slate-300 inline-flex items-center gap-1.5"><Lightning size={12} weight="fill" className="shrink-0" /> {items.length} action(s) promue(s) au Commando — absentes ici (zéro doublon)</span>
        {open ? <CaretUp size={14} /> : <CaretDown size={14} />}
      </button>
      {open && items.map((p, i) => (
        <div key={i} className={`py-1 border-t border-white/10 ${p.tier === "file" ? "text-slate-300 italic" : ""}`} data-testid={`taches-promoted-item-${i}`}>
          <span className="font-bold">{p.objet}</span><span className="text-slate-300"> — {p.why}</span>
        </div>
      ))}
    </div>
  );
}
